import axios from 'axios';

const API_BASE_URL = 'https://stu148664.webhosting.arden.ac.uk/COM6008/api';

// Create axios instance
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors - DISABLED
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Authentication redirect disabled - handle 401 errors without redirect
    if (error.response?.status === 401) {
      console.log('401 error received but redirect disabled:', error.response);
      // Only clear localStorage, no redirect
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
    }
    return Promise.reject(error);
  }
);

export default axiosInstance; 